export const getBuildId = () => {
   return (process.env.NEXT_BUILD_ID && process.env.NEXT_BUILD_ID !=='development') ? process.env.NEXT_BUILD_ID :  '1'
}